var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelmet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10801",
    "data-name": "Grupo 10801",
    transform: "translate(-11168 -1182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firehelmet",
    transform: "translate(11171 1184.425)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17671",
    "data-name": "Rect\\xE1ngulo 17671",
    width: 24.249,
    height: 24.249,
    rx: 12.125,
    fill: "#f5f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10638",
    "data-name": "Grupo 10638",
    transform: "translate(3.031 4.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10634",
    "data-name": "Grupo 10634",
    transform: "translate(1.963 10.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2151",
    "data-name": "Trazado 2151",
    d: "M43.958,258.1a.312.312,0,0,1-.143-.035,4.373,4.373,0,0,1-2.235-4.963.313.313,0,0,1,.606.155,3.761,3.761,0,0,0,.207,2.441,3.7,3.7,0,0,0,1.709,1.812.313.313,0,0,1-.144.59Z",
    transform: "translate(-41.447 -252.869)",
    fill: "#959ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2152",
    "data-name": "Trazado 2152",
    d: "M283.226,258.11a.313.313,0,0,1-.143-.59,3.7,3.7,0,0,0,1.709-1.812,3.76,3.76,0,0,0,.206-2.44.312.312,0,0,1,.606-.155,4.372,4.372,0,0,1-2.234,4.963A.311.311,0,0,1,283.226,258.11Z",
    transform: "translate(-271.477 -252.877)",
    fill: "#959ab7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10635",
    "data-name": "Grupo 10635",
    transform: "translate(0 1.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2153",
    "data-name": "Trazado 2153",
    d: "M79.228,49.554h4.656V46.988A5,5,0,0,0,79.228,42h-2a5,5,0,0,0-4.656,4.984v2.566h6.656Z",
    transform: "translate(-69.134 -42.004)",
    fill: "#959ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2154",
    "data-name": "Trazado 2154",
    d: "M14.749,201.431H3.437L0,203.4a23.468,23.468,0,0,0,18.187,0Z",
    transform: "translate(0 -193.881)",
    fill: "#959ab7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10636",
    "data-name": "Grupo 10636",
    transform: "translate(0 1.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2155",
    "data-name": "Trazado 2155",
    d: "M77.63,42h-.4a5,5,0,0,0-4.656,4.984v2.566h2.276V46.989C74.848,44.344,76.076,42.179,77.63,42Z",
    transform: "translate(-69.134 -42.005)",
    fill: "#959ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2156",
    "data-name": "Trazado 2156",
    d: "M5.713,201.431l-.853,3.422A23.465,23.465,0,0,1,0,203.4l3.437-1.974Z",
    transform: "translate(0 -193.881)",
    fill: "#959ab7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10637",
    "data-name": "Grupo 10637",
    transform: "translate(6.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2157",
    "data-name": "Trazado 2157",
    d: "M137.046,88.051l-1.1,3.38h-3.554l-1.1-3.38,1.875-1.362,1-.727,1,.727Z",
    transform: "translate(-131.296 -82.868)",
    fill: "#959ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2158",
    "data-name": "Trazado 2158",
    d: "M172.885,21.64v2.82h-2V21.64a1,1,0,0,1,2,0Z",
    transform: "translate(-169.01 -20.64)",
    fill: "#959ab7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2159",
    "data-name": "Trazado 2159",
    d: "M170.886,21.64v2.82h.708V21.64c0-.552.131-1,.292-1A1,1,0,0,0,170.886,21.64Z",
    transform: "translate(-162.793 -20.64)",
    fill: "#959ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2160",
    "data-name": "Trazado 2160",
    d: "M133.172,86.689l1-.727,1,.727,1.875,1.362-1.1,3.38h-3.554l-1.1-3.38Z",
    transform: "translate(-125.078 -82.868)",
    fill: "#f5f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2161",
    "data-name": "Trazado 2161",
    d: "M166.09,113.634c0,1.5-1.063,1.247-1.039,2.264a1.051,1.051,0,0,0,1.038.966.934.934,0,0,1,.186-1.5c.029.578.508.67.508,1.086a.759.759,0,0,1-.08.37,1.115,1.115,0,0,0,.888-.948C167.754,114.512,166.09,113.634,166.09,113.634Z",
    transform: "translate(-157.234 -109.23)",
    fill: "#959ab7"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17733",
    "data-name": "Rect\\xE1ngulo 17733",
    width: 30,
    height: 30,
    transform: "translate(11168 1182)",
    fill: "#fff",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.3c0ad23dfde710c0a3249495a376bca9.svg";
export { ForwardRef as ReactComponent };